import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useState, useEffect } from 'react'
import { DISCARD_CHANGES_CONFIRMATION } from '../constants/appMessages'
import { sanitizeUID } from '../helpers/utils'
import LoadingScreen from '../components/LoadingScreen'

const CreateNewClientView = () => {
  const [isFetching, setIsFetching] = useState(true)
  const [failedCreation, setFailedCreation] = useState(false)
  const [data, setData] = useState(null)
  const [failedCreationInfo, setFailedCreationInfo] = useState('')
  const [formState, setFormState] = useState({
    client_group_id: '',
    sales_channel_id: '',
    payment_type_id: '',
    credit_term_id: '',
    country_id: '',
    province_id: '',
    district_id: '',
    town_id: '',
    price_list_id: '',
    price_list_name: '',
    db_ref: '',
    active: true,
    taxpayer_id: '',
    taxpayer_verificator_digit: '',
    business_name: '',
    commercial_name: '',
    customer_name_db_ref: '',
    credit_limit: '',
    legal_representative: '',
    billing_contact_name: '',
    billing_contact_email: '',
    billing_contact_phone: '',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    city: '',
    street: '',
    location_description: '',
    geographical_latitude: 0.0,
    geographical_longitud: 0.0,
    is_cash_client: undefined
  })

  const [provinces, setProvinces] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])

  const [title, setTitle] = useState('Cliente nuevo');

  useEffect(() => {
    fetchDataToCreate()
  }, [])

  const fetchDataToCreate = () => {
    Promise.all([
      authFetch(`${BASE_BACKEND_URL}/clients/new`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        if (!response) return
        return response.json()
      }),
    ])
      .then(([clientData]) => {
        setData(clientData)
        setIsFetching(false)
      })
      .catch((e) => console.log(e))
  }

  const fetchProvinces = (country_id) => {
    authFetch(`${BASE_BACKEND_URL}/provinces/${country_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        const provincesArray = Array.isArray(data) ? data : [data]
        setProvinces(provincesArray)
        setDistricts([])
        setTowns([])
        setFormState((prevState) => ({
          ...prevState,
          province_id: '',
          district_id: '',
          town_id: ''
        }))
      })
      .catch((e) => console.log(e))
  }

  const fetchDistricts = (province_id) => {
    authFetch(`${BASE_BACKEND_URL}/districts/${province_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        const districtsArray = Array.isArray(data) ? data : [data]
        setDistricts(districtsArray)
        setTowns([])
        setFormState((prevState) => ({
          ...prevState,
          district_id: '',
          town_id: ''
        }))
      })
      .catch((e) => console.log(e))
  }

  const fetchTowns = (district_id) => {
    authFetch(`${BASE_BACKEND_URL}/towns/${district_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        const townsArray = Array.isArray(data) ? data : [data]
        setTowns(townsArray)
        setFormState((prevState) => ({ ...prevState, town_id: '' }))
      })
      .catch((e) => console.log(e))
  }
  const handleCreateClientSubmit = (event) => {
    event.preventDefault()
    if (!isFetching) {
      authFetch(`${BASE_BACKEND_URL}/clients`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formState)
      })
        .then((r) => {
        if (!r) return
        return r.json().then((data) => ({ status: r.status, body: data }))
      })
        .then((obj) => evaluateResponse(obj))
        .catch((e) => console.log(e))
    }
  }

  const evaluateResponse = (obj) => {
    switch (obj.status) {
      case 422:
        setFailedCreationInfo('Verifique la información')
        setFailedCreation(true)
        break
      case 409:
        setFailedCreationInfo(
          'No se puede crear cliente. Código ya está en uso. Verifique los datos del cliente'
        )
        setFailedCreation(true)
        break
      case 404:
        setFailedCreationInfo('Servidor fuera de servicio')
        setFailedCreation(true)
        break
      case 500:
        setFailedCreationInfo('Error interno en el sistema')
        setFailedCreation(true)
        break
      default: {
        const data = obj.body
        const clientId = data['id']
        const url = `/clientes/${clientId}/detalles?successCreateForNewClient=true`

        window.location.href = url
        break
      }
    }
  }

  const handleCancelCreate = (event) => {
    event.preventDefault()
    if (window.confirm(DISCARD_CHANGES_CONFIRMATION)) {
      window.location.href = '/clientes'
    }
  }

  const handleChange = (event) => {
    const { name, value, options, selectedIndex } = event.target

    const updateFormState = (updates) => {
      setFormState((prevState) => ({ ...prevState, ...updates }))
    }

    const handleDependentFields = () => {
      const handlers = {
        country_id: fetchProvinces,
        province_id: fetchDistricts,
        district_id: fetchTowns
      }

      if (handlers[name]) {
        handlers[name](value)
      }
    }

    if (name === 'payment_type_selection') {
      updateFormState({ is_cash_client: value === 'contado' })
      return
    }

    if (name === 'price_list_id') {
      const selectedPrice = data.price_list.find((item) => item.id.toString() === value);
      if (selectedPrice) {
        updateFormState({
          price_list_id: selectedPrice.id,
          price_list_name: selectedPrice.db_ref
        });
      } else {
        updateFormState({
          price_list_id: '',
          price_list_name: ''
        });
      }
      return
    }

    if (name === 'db_ref') {
      updateFormState({ db_ref: sanitizeUID(value) })
      return
    }

    updateFormState({ [name]: value })
    handleDependentFields()
  }

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      {failedCreation === true && (
        <div className="alert alert-danger" role="alert">
          <strong>{failedCreationInfo}</strong>
        </div>
      )}
      <div>
        <div className="show-title">
          <h2>{title}</h2>
        </div>
      </div>
      <div className="index-table">
        {!isFetching && (
          <div className="show-area">
            <form onSubmit={handleCreateClientSubmit} className="create-new-salesman">
              <div className="inline-block full-width flex-container">
                <div className="float-left">
                  <div className="new-client-subtitle-font">
                    Ingrese los siguientes datos para crear un cliente nuevo
                  </div>
                </div>
                <div className="float-right">
                  <button onClick={handleCancelCreate} className="cancel-button">
                    Cancelar
                  </button>
                  <input className="save-button" value="Guardar" type="submit" />
                </div>
              </div>
              <hr />
              <div className="red mb-10">
                Por favor, complete los campos obligatorios marcados con * para proceder
              </div>
              {data && (
                <>
                  {/* Comienzo de Formulario */}
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Nombre de cliente en sistema: <span className="red">*</span>
                    </label>

                    <input
                      type="text"
                      onChange={handleChange}
                      name="customer_name_db_ref"
                      value={formState.customer_name_db_ref}
                      className="form-control client-form-input-width"
                      required
                      placeholder="Nombre cliente en sistema"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Código cliente: <span className="red">*</span>
                    </label>

                    <input
                      type="text"
                      name="db_ref"
                      onChange={handleChange}
                      value={formState.db_ref}
                      className="form-control client-form-input-width"
                      required
                      placeholder="1234"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Lista de Precio que le aplica:
                    </label>
                    <select
                      name="price_list_id"
                      value={formState.price_list_id}
                      onChange={handleChange}
                      className={`form-control custom-select client-form-input-width`}
                    >
                      <option value="">
                        Escoja una opción
                      </option>
                      {data.price_list?.map((obj) => (
                        <option key={obj.id} value={obj.id}>
                          {obj.description}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Aqui va el separador para campos opcionales */}
                  <div className="flex-direction-column">
                    <div className="optional-separator">CAMPOS OPCIONALES: </div>
                    <hr className="mt-0 mb-30 fullwidth" />
                  </div>

                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="payment_type_selection" className="col-sm-3 col-form-label">
                      Tipo de Pago:
                    </label>
                    <select
                      name="payment_type_selection"
                      onChange={handleChange}
                      className="form-control custom-select client-form-input-width"
                      defaultValue=""
                    >
                      <option value="" hidden disabled>
                        Escoja una opción
                      </option>
                      <option value="contado">Contado</option>
                      <option value="credito">Crédito</option>
                    </select>
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Activo:
                    </label>
                    <select
                      name="active"
                      onChange={handleChange}
                      className={`form-control custom-select client-form-input-width`}
                    >
                      <option value="true">Si</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      RUC:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="taxpayer_id"
                      value={formState.taxpayer_id}
                      className="form-control client-form-input-width"
                      placeholder="0000000-0-000000"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      DV:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="taxpayer_verificator_digit"
                      value={formState.taxpayer_verificator_digit}
                      className="form-control client-form-input-width"
                      placeholder="00"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Razón social:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="business_name"
                      value={formState.business_name}
                      className="form-control client-form-input-width"
                      placeholder="Razón Social"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Nombre comercial:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="commercial_name"
                      value={formState.commercial_name}
                      className="form-control client-form-input-width"
                      placeholder="Nombre comercial"
                    />
                  </div>

                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Monto de crédito:
                    </label>
                    <input
                      min="0"
                      max="999999"
                      type="number"
                      onChange={handleChange}
                      name="credit_limit"
                      value={formState.credit_limit}
                      className="form-control client-form-input-width"
                      placeholder="0.00"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Representante legal:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="legal_representative"
                      value={formState.legal_representative}
                      className="form-control client-form-input-width"
                      placeholder="Nombre representante legal"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Persona de contacto para cobro:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="billing_contact_name"
                      value={formState.billing_contact_name}
                      className="form-control client-form-input-width"
                      placeholder="Persona de contacto para cobro"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Pago correo electrónico:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="billing_contact_email"
                      value={formState.billing_contact_email}
                      className="form-control client-form-input-width"
                      placeholder="Correo electrónico de pago"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Pago teléfono:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="billing_contact_phone"
                      value={formState.billing_contact_phone}
                      className="form-control client-form-input-width"
                      placeholder="0000-0000"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Persona de contacto:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="contact_name"
                      value={formState.contact_name}
                      className="form-control client-form-input-width"
                      placeholder="Nombre persona de contacto"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Correo electrónico:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="contact_email"
                      value={formState.contact_email}
                      className="form-control client-form-input-width"
                      placeholder="Correo electrónico persona de contacto"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Teléfono:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="contact_phone"
                      value={formState.contact_phone}
                      className="form-control client-form-input-width"
                      placeholder="0000-0000"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Ciudad:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="city"
                      value={formState.city}
                      className="form-control client-form-input-width"
                      placeholder="Ciudad"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Calle:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="street"
                      value={formState.street}
                      className="form-control client-form-input-width"
                      placeholder="Calle"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Guía de Ubicación:
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="location_description"
                      value={formState.location_description}
                      className="form-control client-form-input-width"
                      placeholder="Guía de Ubicación"
                    />
                  </div>

                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Longitud (grados decimales):
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="geographical_longitud"
                      value={formState.geographical_longitud}
                      className="form-control client-form-input-width"
                      placeholder="00.000000"
                    />
                  </div>
                  <div className="data-row justify-content-flex-start">
                    <label htmlFor="inputName" className="col-sm-3 col-form-label">
                      Latitud (grados decimales):
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="geographical_latitude"
                      value={formState.geographical_latitude}
                      className="form-control client-form-input-width"
                      placeholder="00.000000"
                    />
                  </div>
                </>
              )}
            </form>
          </div>
        )}
      </div>
    </>
  )
}

export default CreateNewClientView
